var sw = sw || {};


// Enable responsive youtube video
//-----------------------------------------------------------------
sw.responsiveVideo = function() {
    var $parentEl = $('.wysiwyg');

    if (!$parentEl.length) {
        return;
    }

    var $allVideos = $('iframe').filter(function(){return this.src.match(/(youtube\.com|youtu\.be)/i);});

    $allVideos.each(function() {
        var _aspectRatio = this.height / this.width * 100;

        $(this).wrap('<div class="video-container"></div>');
        $(this).parent().css('padding-bottom', _aspectRatio+'%');
    });
};


// Enable "sticky" sidebar
//-----------------------------------------------------------------
sw.stickyFill = function() {
    var stickyElements = document.getElementsByClassName('sticky');

    for (var i = stickyElements.length - 1; i >= 0; i--) {
        Stickyfill.add(stickyElements[i]);
    }
};



// Enable fancy scrollbars
//-----------------------------------------------------------------
sw.perfectScrollbar = function() {
    var $psEl = $('.js_ps');

    if (!$psEl.length) {
        return;
    }

    $psEl.each(function(){
        const ps = new PerfectScrollbar($(this)[0]); 
    });
};




// Hero full width/height screen
//-----------------------------------------------------------------
sw.heroResize = function() {

    var $hero = $('.hero'),
        $heroSlide = $('.hero').find('.swiper-slide'),
        _headerHeight = $('.header').height();

    if (!$hero.length) {
        return;
    }

    function resizeHero() {
        var _vpw = $(window).width();
        var _vph = $(window).height();
        var _offset = _vph - _headerHeight;


        if( _vpw > 1024 ) {
            $('.hero').css({'height': _offset + 'px'});

            $heroSlide.each( function() {
                $(this).css({'height': _offset + 'px'});
            });
        }

    }

    resizeHero();

    $(window).bind('resizeEnd', function() {
        resizeHero();
    });
};



$(document).ready(function (){
    sw.responsiveVideo();
    sw.perfectScrollbar();
    sw.heroResize();
});